<template>
  <div>
    <div id="white-container">
      <div id="top-container">
        <div id="left-line"/>
        <p id="share-initiative">
          PLEASE SHARE THIS INITIATIVE<br>
          WITH EVERY BUSINESS OWNER YOU KNOW<br>
          SO WE CAN BE HEARD!
        </p>
        <div id="right-line"/>
      </div>
    </div>
    <div id="black-container">
      <div id="bottom-container">
        <div id="left-side">
          <div id="stay-in-touch">STAY IN TOUCH</div>
          <div id="enter-your-email">
            Enter your email to subscribe to news and
            updates to this initiative.
          </div>
          <div id="email-container">
            <input v-model="email" type="email" id="email-input" name="email" placeholder="Email Address">
            <button ref="subscribe" @click="subscribeClicked" :disabled="subscribed">{{subscribed ? 'DONE' : 'SUBSCRIBE'}}</button>
          </div>
          <div id="terms-of-service">
            <span @click="showTermsOfUse">Terms of Service</span>
            <span style="display:inline-block; width: 10px;"></span>
            <span @click="showPrivacyPolicy">Privacy Policy</span>
          </div>
        </div>
        <div id="right-side">
          <div id="contact-us">CONTACT US</div>
          <div id="suggestions">
            If you have issues, questions, or suggestions, or if
            you want us to pass on words of support to entrepreneurs,
            please contact us!
          </div>
          <div id="our-email" @click="contactClicked">contact@supportbiznow.com</div>
          <img src="../assets/instagram-white.svg" id="instagram" @click="instagramClicked">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/firestore'

  export default {
    name: "AppFooter",
    data(){
      return {
        email: '',
        subscribed: false
      }
    },
    methods: {
      showTermsOfUse() {
        this.$root.$emit('isTermsOfService', true)
        this.$emit('showPrivacyPolicy')
      },
      showPrivacyPolicy() {
        this.$root.$emit('isTermsOfService', false)
        this.$emit('showPrivacyPolicy')
      },
      subscribeClicked() {
        if (!this.email) {
          return
        }
        this.subscribed = true
        if (!this.isEmailValid(this.email)) {
          return
        }
        this.$refs.subscribe.style.cursor = 'default'
        firebase.firestore().collection('Emails').doc(this.email).set({})
      },
      isEmailValid(email) {
        const re = /\S+@\S+\.\S+/
        return re.test(email)
      },
      contactClicked() {
        window.location.href = "mailto:contact@supportbiznow.com"
      },
      instagramClicked() {
        window.open('https://www.instagram.com/supportbiznow')
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  #white-container {
    background-color: white;
  }
  #top-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 30px;
  }
  #left-line {
    width: 100px;
    height: 1px;
    margin-right: 20px;
    background-color: #CE6363;
  }
  #right-line {
    width: 100px;
    height: 1px;
    margin-left: 20px;
    background-color: #CE6363;
  }
  #share-initiative {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 1.4vw;
    padding: 0;
    margin: 0;
  }
  #black-container {
    background-color: #232A2E;
  }
  #bottom-container {
    margin: 0 auto;
    width: 85%;
    height: 100%;
    color: white;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  #stay-in-touch {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 13px;
    text-align: left;
  }
  #enter-your-email {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    text-align: left;
    margin-top: 15px;
    width: 350px;
  }
  #email-container {
    display: flex;
    padding-top: 20px;
  }
  #email-input {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    width: 200px;
    padding: 0 10px;
    height: 40px;
    color: white;
    background-color: transparent;
    display: block;
    border: 1px solid white;
    border-radius: 4px;
    box-sizing: border-box;
    outline: none;
    line-height: normal;
  }
  ::placeholder {
    color: white;
    opacity: 1;
  }
  button {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 12px;
    background-color: white;
    border: none;
    border-radius: 4px;
    color: #232A2E;
    margin-left: 20px;
    width: 120px;
    height: 40px;
    padding: 12px 0;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
  }
  #terms-of-service {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 13px;
    text-align: left;
    margin-top: 20px;
    color: #6C6C6C;
  }
  #terms-of-service span {
    text-decoration: underline;
    cursor: pointer;
  }
  #contact-us {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 13px;
    text-align: left;
  }
  #suggestions {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    text-align: left;
    margin-top: 15px;
    width: 350px;
  }
  #our-email {
    font-family: "Avenir Next", openSans, serif;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    margin-top: 15px;
    cursor: pointer;
  }
  #instagram {
    display: block;
    margin-top: 15px;
    cursor: pointer;
  }

  /*DESKTOPS*/
  @media only screen and (min-width: 769px) {
    #bottom-container {
      display: flex;
    }
    #right-side {
      width: 340px;
      margin-left: auto;
    }
  }

  /*LARGE DESKTOPS*/
  @media only screen and (min-width: 1440px) {
    #share-initiative {
      font-size: 20px;
    }
    #bottom-container {
      margin: 0 112px;
      width: auto;
    }
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #top-container {
      padding: 25px 15px;
    }
    #left-line {
      width: 20px;
      margin-right: 10px;
    }
    #right-line {
      width: 20px;
      margin-left: 10px;
    }
    #share-initiative {
      font-size: 9px;
    }
    #bottom-container {
      padding-top: 15px;
      padding-bottom: 15px;
      width: 100%;
    }
    #left-side {
      margin: 0 auto;
      width: 220px;
    }
    #stay-in-touch {
      font-size: 10px;
    }
    #enter-your-email {
      margin-top: 8px;
      font-size: 10px;
      width: 220px;
    }
    #email-container {
      display: flex;
      padding-top: 15px;
    }
    #email-input {
      font-size: 10px;
      width: 130px;
      padding: 0 6px;
      height: 30px;
    }
    button {
      font-size: 8px;
      margin-left: 10px;
      padding: 0;
      width: 80px;
      height: 30px;
    }
    #terms-of-service {
      font-size: 10px;
      margin-top: 15px;
    }
    #right-side {
      margin: 30px auto 0 auto;
      width: 220px;
    }
    #contact-us {
      font-size: 10px;
    }
    #suggestions {
      margin-top: 8px;
      font-size: 10px;
      width: 220px;
    }
    #our-email {
      font-size: 10px;
      margin-top: 10px;
    }
    #instagram {
      display: block;
      margin-top: 15px;
      cursor: pointer;
    }
  }
</style>